import React, { useState } from "react";
import { useEffect } from "react";
import * as Constantes from "../../../../utils/constantes";
import BotonExpandir from "../boton-expandir";
import TablaProyeccionesFU from "../tabla-proyecciones-fu";
import TerminosCondiciones from "../terminos-condiciones";
import TituloEscenario from "../titulo-escenario";
import styles from "./proyeccion-fu.module.css";

const ProyeccionFU = ({ producto, textosLegales }) => {
    const initialState = {
        proyecciones: [],
        expandido: false,
        textosLegales: textosLegales !== null
            ? textosLegales.filter(textoLegal => textoLegal.codigoProducto === producto.codigoProducto).map((textoLegal) => {
                return {
                    id: textoLegal.codigoTxtLegal,
                    descripcion: textoLegal.detalleTxtLegal
                }
            }) : undefined
    }

    const [ state, setState ] = useState(initialState);

    const expandirTabla = () => {
        setState({
            ...state,
            proyecciones: !state.expandido
                ? producto.escenarios[0].proyecciones
                : producto.escenarios[0].proyecciones.filter(proyeccion => (proyeccion.anio === 1 || proyeccion.anio % 5 === 0))
                    .slice(0, Constantes.CANTIDAD_REGISTROS_PROYECCIONES),
            expandido: !state.expandido
        })
    }

    useEffect(() => {
        setState({
            ...state,
            proyecciones: producto.escenarios[0].proyecciones.filter(proyeccion => (proyeccion.anio === 1 || proyeccion.anio % 5 === 0))
                .slice(0, Constantes.CANTIDAD_REGISTROS_PROYECCIONES),
            expandido: false
        })
    }, [ producto ])

    return (
        <React.Fragment>
            <div className={styles.body}>
                <TituloEscenario
                    titulo='Valores de retorno'
                />
                <TablaProyeccionesFU
                    proyecciones={state.proyecciones}
                    moneda={producto.moneda}
                />
                <BotonExpandir
                    proyecciones={state.proyecciones}
                    expandido={state.expandido}
                    expandirTabla={expandirTabla}
                    mostrarPoliticaInversion={false}
                />
                <TerminosCondiciones
                    terminosCondiciones={state.textosLegales}
                />
            </div>
        </React.Fragment>
    )
}

export default ProyeccionFU;